import { render, staticRenderFns } from "./CustomIntegration.vue?vue&type=template&id=1839e344&scoped=true"
import script from "./CustomIntegration.vue?vue&type=script&lang=js"
export * from "./CustomIntegration.vue?vue&type=script&lang=js"
import style0 from "./CustomIntegration.vue?vue&type=style&index=0&id=1839e344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1839e344",
  null
  
)

export default component.exports